import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteMasterSlice = createSlice({
  name: 'DeletePackage',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deletePackage: (state, _) => {
      state.isLoading = true;
    },
    successDeletePackage: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeletePackage: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeletePackage: (state) => {
      state.data = {};
    },
  },
});

export const {
  successDeletePackage,
  failureDeletePackage,
  deletePackage,
  clearDeletePackage,
} = DeleteMasterSlice.actions;

export default DeleteMasterSlice.reducer;
